import type * as os from 'os'

import { isElectron } from '@/utils/device-type'

class NodeNetwork {
  private network: any

  constructor() {
    const os = window.require('os')
    this.network = os
  }

  /**
   * Gets the subnet prefix of the first non-internal IPv4 address found on the system.
   
    * @returns {string | null} The subnet prefix in the format 'x.x.x.' or null if no suitable address is found.
   */
  getSubnetPrefix() {
    const interfaces = this.network.networkInterfaces() as NodeJS.Dict<os.NetworkInterfaceInfo[]>

    for (const ifaceList of Object.values(interfaces)) {
      if (!ifaceList) continue
      for (const iface of ifaceList) {
        if (iface.family === 'IPv4' && !iface.internal) {
          const ipParts = iface.address.split('.')
          return ipParts.slice(0, 3).join('.') + '.'
        }
      }
    }

    return null
  }
}

export default class NetworkFactory {
  static getNetwork() {
    if (isElectron) {
      return new NodeNetwork()
    } else {
      throw new Error('Socket not supported in this environment')
    }
  }
}
